export default __webpack_public_path__ + "static/media/RecomKba.afea8bce.png";